__turbopack_context__.v({
  "placeholder__container": "profile-picture-placeholder-module-scss-module__LHwZkW__placeholder__container",
  "placeholder__container--1": "profile-picture-placeholder-module-scss-module__LHwZkW__placeholder__container--1",
  "placeholder__container--2": "profile-picture-placeholder-module-scss-module__LHwZkW__placeholder__container--2",
  "placeholder__container--3": "profile-picture-placeholder-module-scss-module__LHwZkW__placeholder__container--3",
  "placeholder__container--4": "profile-picture-placeholder-module-scss-module__LHwZkW__placeholder__container--4",
  "placeholder__container--5": "profile-picture-placeholder-module-scss-module__LHwZkW__placeholder__container--5",
  "placeholder__text": "profile-picture-placeholder-module-scss-module__LHwZkW__placeholder__text",
});
